//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PaginationFirestore',
  props: {
    pagination: {},
    pageType: {
      type: String,
      default: '1'
    }
  },
  created: function created() {},
  computed: {
    getTotalPages: function getTotalPages() {
      if (this.pageType === '1') {
        return this.pagination.next ? this.pagination.current + 1 : this.pagination.current;
      } else if (this.pageType === '2') {
        return this.pagination.total ? Math.ceil(this.pagination.total / this.pagination.limit) : 0;
      } else {
        return 0;
      }
    }
  },
  methods: {
    goFirst: function goFirst() {
      this.pagination.current = 1;
      this.emitChange();
    },
    goNext: function goNext() {
      this.emitChange();
    },
    goPrev: function goPrev() {
      this.emitChange();
    },
    emitChange: function emitChange() {
      this.$emit('changePagina', this.pagination.current);
    },
    goPage: function goPage() {
      this.emitChange();
    },
    getTotalPage: function getTotalPage() {
      return Math.ceil(this.pagination.total / this.pagination.limit);
    }
  }
};